export default class TemplatesListController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        this.state = this.injector.get('$state');
        this.templatesStore = this.injector.get('Templates');
        this.navService = this.injector.get('NavService');
        this.translate = this.injector.get('$translate');
        this.stateParams = this.injector.get('$stateParams');

        this.currentTab = this.stateParams.startTab;

        this._updateCustomActions();
        this._initStore();
    }

    _changeTab(newTab) {
        this.currentTab = newTab;
        this._initStore();
        this._updateCustomActions();
        this.templatesStore.dispatch('getData');
    }

    _initStore() {
        this.templatesStore.commit('setEmptyListActions', [
            'create-template'
        ]);

        this.templatesStore.commit('setVm', this);
        this.templatesStore.dispatch('loadWorkflows', 'templates::list');

        switch (this.currentTab) {
            case 'shared':
                this.templatesStore.commit('setOnlyGlobal', true);
                this.templatesStore.commit('setOnlyScoped', false);
                break;
            case 'linked':
                this.templatesStore.commit('setOnlyGlobal', false);
                this.templatesStore.commit('setOnlyScoped', true);
                break;
        }
    }

    _updateCustomActions() {
        this.navService.setSideNavCustoms([
            {
                label: this.translate.instant('templates.pages.list.tabs.shared'),
                active: (this.currentTab === 'shared'),
                icon: 'chart-network',
                order: 5,
                action: () => {
                    this._changeTab('shared');
                }
            },
            {
                label: this.translate.instant('templates.pages.list.tabs.regular'),
                active: (this.currentTab === 'linked'),
                icon: 'file',
                order: 10,
                action: () => {
                    this._changeTab('linked');
                }
            }
        ]);
    }
}

TemplatesListController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/templates/controllers/pages/list-controller.js